import { useState } from "react";
import { Button, Checkbox } from "..";
import "./AuthForm.scss";
import { CaptchaWidget } from "../CaptchaWidget/CaptchaWidget";

function LoginForm({
  onSwitchToRegister,
  onSubmit,
  onForgotPassword,
  errorMessage,
  loggingIn,
  setLoggingIn,
  setCaptchaToken,
}) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoggingIn(true);
    onSubmit?.({ email, password });
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <div className="auth-form__field">
        <label className="auth-form__label" htmlFor="login-email">
          Email
        </label>
        <input
          id="login-email"
          type="email"
          className="auth-form__input"
          placeholder="vas@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
        />
      </div>

      <div className="auth-form__field">
        <label className="auth-form__label" htmlFor="login-password">
          Heslo
        </label>
        <input
          id="login-password"
          type="password"
          className="auth-form__input"
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
        />
      </div>

      <div className="auth-form__row">
        <button
          type="button"
          className="auth-form__link"
          onClick={onForgotPassword}
        >
          Zabudnuté heslo?
        </button>
      </div>
      <CaptchaWidget onVerify={(token) => setCaptchaToken(token)} />

      {errorMessage && <div className="auth-form__error">{errorMessage}</div>}

      <div className="auth-form__submit">
        <Button
          variant="primary"
          type="submit"
          style={{ width: "100%" }}
          disabled={loggingIn}
        >
          {loggingIn ? "Prihlasujem..." : "Prihlásiť sa"}
        </Button>
      </div>

      {onSwitchToRegister && (
        <p className="auth-form__switch">
          Nemáte účet?{" "}
          <button
            type="button"
            className="auth-form__link"
            onClick={onSwitchToRegister}
          >
            Registrujte sa
          </button>
        </p>
      )}
    </form>
  );
}

export default LoginForm;
